import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Actions, ofType } from '@ngrx/effects';
import { map, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromProjectActions from './projects.actions';
import {
  NotificationType,
  ShiveNotificationService,
} from '../../services/controls/shive-notification.service';
import { ProjectModel } from '../../models/project/project.model';
import { ProjectStatusFilter } from '../../../pages/project/shared/project-detail-types';

@Injectable({
  providedIn: 'root',
})
export class ProjectsHttpService {
  private readonly store = inject(Store);
  private readonly shiveNotificationService = inject(ShiveNotificationService);
  private readonly actions$ = inject(Actions);

  constructor() {
    this.handleHttpCallbacks();
  }

  public getProjects(clientId?: number, filter?: ProjectStatusFilter): Observable<ProjectModel[]> {
    this.store.dispatch(
      fromProjectActions.fetchProjects({ payload: { clientId, projectStatusFilter: filter } }),
    );

    return this.actions$.pipe(
      ofType(fromProjectActions.setProjects),
      map((result) => result.payload),
      take(1),
    );
  }

  public getSingleProject(projectId: number): Observable<ProjectModel> {
    this.store.dispatch(
      fromProjectActions.fetchSingleProject({
        payload: projectId,
      }),
    );

    return this.actions$.pipe(
      ofType(fromProjectActions.setSingleProject),
      map((result) => result.payload),
      take(1),
    );
  }

  public addProject(projectModel: ProjectModel): Observable<ProjectModel> {
    this.store.dispatch(
      fromProjectActions.addProject({
        payload: projectModel,
      }),
    );

    return this.actions$.pipe(ofType(fromProjectActions.projectAdded));
  }

  public updateProject(projectModel: ProjectModel): Observable<ProjectModel> {
    this.store.dispatch(
      fromProjectActions.updateProject({
        payload: projectModel,
      }),
    );

    return this.actions$.pipe(ofType(fromProjectActions.projectUpdated));
  }

  public deleteProject(toBeDeletedProject: ProjectModel): Observable<ProjectModel> {
    this.store.dispatch(
      fromProjectActions.deleteProject({
        payload: toBeDeletedProject,
      }),
    );

    return this.actions$.pipe(ofType(fromProjectActions.projectDeleted));
  }

  private handleHttpCallbacks(): void {
    this.actions$
      .pipe(
        ofType(
          fromProjectActions.projectAdded,
          fromProjectActions.projectUpdated,
          fromProjectActions.projectDeleted,
        ),
      )
      .subscribe(() => {
        // const message = this.localizationService.getTranslation(payload.responseCode);
        this.shiveNotificationService.show(NotificationType.Success);
      });
  }
}
